import React from 'react'
import OrangeLocatorDeviceSales from '../components/dashboard/OrangeLocatorDeviceSales'

const OrangeLocatorDeviceSalesPage = () => <OrangeLocatorDeviceSales />

export default OrangeLocatorDeviceSalesPage
